import { StateParams } from "@uirouter/angularjs";
import { IOnInit, ICompileService } from "angular";
import { RecordDataSource } from "../../../records/grids";
import { ColDef } from "../../../records/grids/columns/colDef";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../records/grids/columns/columnDefinitionService";
import {
  GridSettingsService,
  IGridSettings,
  vsName as GridSettingsServiceName,
} from "../../../records/grids/settings/gridSettingsService";
import { IQuery } from "../../../records/server/query";
import {
  GridConfiguration,
  RecordGridViewService,
  vsServiceName as RecordGridViewServiceName,
} from "../../../records/views/recordGridView";
import {
  vsName as serverUtilityName,
  ServerUtility,
} from "../../../../app/records/server/serverUtility";

import "angular-formly";
const gridId = Symbol("main.contract.bulklog");
export class BulkLogController implements IOnInit {
  static $inject = [
    "$stateParams",
    "slotTrakMachinesServer",
    serverUtilityName,
    GridSettingsServiceName,
    ColumnDefinitionServiceName,
    RecordGridViewServiceName,
    "$compile",
  ];
  readonly gridDataSource: RecordDataSource;
  readonly gridSettings: IGridSettings;
  readonly columns: ColDef[];
  readonly defaultQuery: IQuery = {};
  initialMachineIds = {};
  contractMachines!: any;
  contractId: string = "";

  constructor(
    public readonly $stateParams: StateParams,
    public readonly slotTrakMachinesServer: any,
    public readonly serverUtility: ServerUtility,
    gridSettingsService: GridSettingsService,
    columnDefinitionService: ColumnDefinitionService,
    private readonly recordGridViewService: RecordGridViewService,
    $compile: ICompileService
  ) {
    this.contractId = this.$stateParams["contractId"];
    this.gridDataSource = new RecordDataSource(
      serverUtility,
      "/api/contract/bulklog/"
    );
    this.gridSettings = gridSettingsService.getGridSettings(gridId);

    const gridConfiguration: GridConfiguration | undefined =
      this.recordGridViewService.getGridConfiguration("machine");
    if (!gridConfiguration) {
      throw new Error(
        "Must have machineConfiguration registered with recordGridViewService"
      );
    }

    this.columns = [
      columnDefinitionService.getLinkColDef({
        colId: "info",
        headerName: " ",
        iconClass: "fa fa-info-circle text-primary",
        stateExpression:
          "main.contract.bulklog.results({ logId: data.Id})",
        requiresPermission: "contractView",
      }),
      columnDefinitionService.getNumberColDef({
        field: "Id",
        header: "Id",
      }),
      columnDefinitionService.getNumberColDef({
        field: "TotalIds",
        header: "Total Numbers",
      }),
      columnDefinitionService.getNumberColDef({
        field: "Succeeded",
        header: "Succeeded",
        
      }),
      columnDefinitionService.getDateColDef({
        field: "CreatedDate",
        header: "Created Date",
      }),
    ];
  }

  $onInit(): void {}
}
